const isLocalhost = (): boolean => {
  return window.location.hostname === 'localhost'
}

export const cookieOptions = {
  path: '/',
  domain: isLocalhost() ? undefined : '.musescabinets.com',
  secure: !isLocalhost(),
  sameSite: isLocalhost() ? ('Lax' as const) : ('None' as const)
}
